<template>
    <div v-if="canUpdate">
        <settings-heading
            :title="$t('settings.apikeys.title')"
            :description="$t('settings.apikeys.description')"
        />

        <div class="rounded-6 overflow-hidden mb-16">
            <div class="first-letter:uppercase mb-8">
                {{ $t('settings.apikeys.input') }}
            </div>
            <copy-to-clipboard
                class="w-full"
                :text="key"
                :copy-value="[currentCompany.key, $t('settings.apikeys.name')]"
            />
        </div>

        <div class="flex items-end mb-32">
            <div class="mr-auto">
                <p class="text-primary-80 mr-32">
                    {{ $t('settings.apikeys.footer') }}
                </p>
            </div>
        </div>

        <div class="flex justify-end mb-48">
            <simple-button
                class="flex-none"
                display="secondary"
                icon="replay"
                look="primary"
                :loading="renewingKey"
                @click="submitForm"
            >
                {{ $t('settings.apikeys.button') }}
            </simple-button>
        </div>

    </div>
    <error-403 v-else></error-403>
</template>

<script>
import * as companiesService from '../../services/CompanyService';
import {mapState, mapActions} from 'pinia';
import {useRepo} from "pinia-orm";
import {useMainStore} from '../../state/store';
import {useNotificationsStore} from '../../state/modules/notifications';
import { ADD_NOTIFICATION } from '../../state/mutation-types';
import Company from '../../models/Company';
import SimpleButton from '../../components/ui/SimpleButton.vue';
import Form from '../../etc/forms/Form';
import { normalizeJson, copyToClipboard } from '../../../shared/helpers';
import SvgIcon from '../../components/ui/SvgIcon.vue';
import Loading from '../../components/ui/Loading.vue';
import Error403 from '../../components/ui/Error403.vue';
import CopyToClipboard from "../../components/ui/CopyToClipboard.vue";
import SettingsHeading from "../../components/ui/SettingsHeading.vue";


export default {
    components: {
        SettingsHeading,
        CopyToClipboard,
        'simple-button': SimpleButton,
        'svg-icon': SvgIcon,
        'loading': Loading,
        'error-403': Error403,
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        key () {
            return this.currentCompany.key;
        }
    },
    data: function () {
        return {
            form: new Form([]),
            renewingKey: false,
            canUpdate: this.$can('settings.advanced'),
        }
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        async submitForm () {
            this.renewingKey = true;

            await this.form.submit(data => {
                return companiesService.update(this.currentCompany.id, {data: {attributes: {regenkey: 1}}});
            }).then(result => {
                return useRepo(Company)
                        .whereId(result.id)
                        .update(normalizeJson(result));
            }).then(() => {
                this.form = new Form([]);
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('settings.saved', {subject: this.$t('settings.apikeys.name')}),
                });
            });

            this.renewingKey = false;
        },
    },
}
</script>
